import React, { useState } from "react";
import { Col } from "reactstrap";
import { CommonBohoModalTitle } from "../Common/CommonBohoModalTitle";
import { Btn, Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { BalanceModal } from "./BalanceModal";
import { ClickOut } from "../../../../../Constant";

const ModalThird = () => {
  const [modalThird, setModalThird] = useState(false);
  const modalThirdTogggle = () => setModalThird(!modalThird);
  return (
    <Col xl="4" md="12" className="custom-alert text-center">
      <div className="card-wrapper border rounded-3 h-100">
        <div className="Boho-demo-img">
          <CommonBohoModalTitle heading="Modal 3 -" subHeading="Balance Modal" text="Example of Boho dashboard balance card." />
          <div className="overflow-hidden balance-modal">
            <Image src={dynamicImage("alert/balance.png")} alt="learning" />
            <Btn color="primary" className="mx-auto mt-3" type="button" onClick={modalThirdTogggle}>
              {ClickOut}
            </Btn>
          </div>
          <BalanceModal modalThird={modalThird} modalThirdTogggle={modalThirdTogggle}/>
        </div>
      </div>
    </Col>
  );
};

export default ModalThird;
